import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  Cashbook, CashbookAccessUserRequest, CashbookAccountAccess, MyCashbooks,
} from '../interfaces/cashbook/cashbook.interface';

/** F11 (11b): who may see / post to each cash or bank account. */
export const CashbookAccessService = {
  cashbooks: async (institutionId: string): Promise<Cashbook[]> =>
    (await axios.get(ENDPOINTS.CASHBOOK_ACCESS.ACCOUNTS(institutionId))).data,
  get: async (institutionId: string, accountId: string): Promise<CashbookAccountAccess> =>
    (await axios.get(ENDPOINTS.CASHBOOK_ACCESS.USERS(institutionId, accountId))).data,
  replace: async (institutionId: string, accountId: string, users: CashbookAccessUserRequest[]): Promise<CashbookAccountAccess> =>
    (await axios.put(ENDPOINTS.CASHBOOK_ACCESS.USERS(institutionId, accountId), { users })).data,
  clear: async (institutionId: string, accountId: string): Promise<void> => {
    await axios.delete(ENDPOINTS.CASHBOOK_ACCESS.USERS(institutionId, accountId));
  },
  mine: async (institutionId: string): Promise<MyCashbooks> =>
    (await axios.get(ENDPOINTS.CASHBOOK_ACCESS.MINE(institutionId))).data,
};
